module.exports = __webpack_public_path__ + "img/detalle-15.75f2da3e.png";